import {
  CompanyFilter,
  InclusionMethod,
} from "../../../../legacy/types/companyFilter";
import { abbreviateNumber } from "../../../../utils/numberUtils";

export const formatRevenueRange = (revenueRange: {
  min?: number | null;
  max?: number | null;
}): string => {
  const min = revenueRange?.min;
  const max = revenueRange?.max;

  const hasMin = min !== null && min !== undefined;
  const hasMax = max !== null && max !== undefined;

  if (hasMin && hasMax) {
    if (min === max) {
      return `$${abbreviateNumber(min)}`;
    }
    return `$${abbreviateNumber(min)} - $${abbreviateNumber(max)}`;
  } else if (hasMin) {
    return `Above $${abbreviateNumber(min)}`;
  } else if (hasMax) {
    return `Below $${abbreviateNumber(max)}`;
  }

  return "Unknown";
};

export const transformTechnographicFiltersToInstallFilters = (
  filters: CompanyFilter
) => {
  const productIds = (filters.products || [])
    .filter((p) => p.inclusionMethod !== InclusionMethod.NONE_PRESENT)
    .flatMap((p) => p.ids);

  const vendorIds = (filters.vendors || [])
    .filter((vendor) => vendor.inclusionMethod !== InclusionMethod.NONE_PRESENT)
    .flatMap((vendor) => vendor.ids);

  return {
    countryAlpha2s: filters.countryAlpha2s || [],
    productCategoryIds: filters.productCategories?.ids || [],
    productAttributeIds: filters.productAttributes?.ids || [],
    productIds,
    vendorIds,
    includeCorporateDescendants: false,
  };
};
